"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmpty = exports.removeFromArrayMap = exports.addToArrayMap = void 0;
function addToArrayMap(arrayMap, key, val) {
    arrayMap[key].push(val);
}
exports.addToArrayMap = addToArrayMap;
function removeFromArrayMap(arrayMap, key, val) {
    const indexOfElem = arrayMap[key].findIndex((elem) => elem === val);
    if (indexOfElem !== -1) {
        arrayMap[key].splice(indexOfElem, 1);
    }
}
exports.removeFromArrayMap = removeFromArrayMap;
function isEmpty(val) {
    return val.length === 0;
}
exports.isEmpty = isEmpty;
